<template>
    <c-dialog ref="dialog" title="资产档案转移记录" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <label>{{detailData.asset_code}} | {{detailData.asset_name}}</label>
                <c-state dict="assetUseStatusDic" tag :value="detailData.current_status"></c-state>
            </div>
        </template>

        <div class="m-detail-box">
            <c-table ref="recordList" height="grow" :paging="true">
                <c-table-column label="原网点" width="150">
                    <template #default="{data}">
                        <span>{{data.outlet_name}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="接收网点" width="150">
                    <template #default="{data}">
                        <span>{{data.ref_outlet_name}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="操作人" width="120">
                    <template #default="{data}">
                        <span>{{data.create_user_realname}}</span>
                    </template>
                </c-table-column>

                <c-table-column label="操作时间" width="140">
                    <template #default="{data}">
                        <span>{{data.create_date||'-'}}</span>
                    </template>
                </c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'assetTransferRecordListDialog',
    props: {
    },
    data() {
        return {
            detailData:{}
        }
    },
    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.recordList.load({
                url: '/fixed_asset/operation/record/list',
                data,
                success: () => {}
            });
        },
        open(data) {
            this.detailData = data;
            var params = {}
            params.asset_id = data.id;
            params.operation_types = [3];//表示转移操作记录
            this.searchHandle(params);
            this.$refs.dialog.open();
        }
    }
}
</script>